import { computed } from '@nuxtjs/composition-api';
import { Logger, sharedRef, useVSFContext } from '@vue-storefront/core';

export interface SRPEssentialsResult {
  [key: string]: any;
}

interface UseSRPEssentialsReturn {
  getSRPEssentials: () => Promise<void>;
  SRPEssentialsResult: any;
  SRPEssentialsLoading: any;
  SRPEssentialsError: any;
}

export const useSRPEssentials = (): UseSRPEssentialsReturn => {
  const context = useVSFContext();
  const result = sharedRef<SRPEssentialsResult | null>(null, 'useSRPEssentials');
  const loading = sharedRef<boolean>(false, 'useSRPEssentials-loading');
  const error = sharedRef<{ getSRPEssentials: any | null }>(
    { getSRPEssentials: null },
    'useSRPEssentials-error'
  );

  const getSRPEssentials = async (): Promise<void> => {
    Logger.debug('useSRPEssentials custom componsable');
    try {
      loading.value = true;
      result.value = await context.$novulo.api.getSRPEssentials();
    } catch (err) {
      error.value.getSRPEssentials = err;
      Logger.error('useSRPEssentials', err);
    } finally {
      loading.value = false;
    }
  };

  return {
    getSRPEssentials,
    SRPEssentialsResult: computed(() => result.value),
    SRPEssentialsLoading: computed(() => loading.value),
    SRPEssentialsError: computed(() => error.value)
  };
};
